import { FrLoginInterface } from '@shared/lib/models/fr-login-interface.enum';

export abstract class FrLoginInterfaceMapper {
  abstract loadComponentForInterface(frInterface: FrLoginInterface): Promise<any>;
}
